export default "__VITE_ASSET__DidiR3H3__"